import { autoinject, transient } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "../../../../../../services/basics/notification-client.service";
import { OnboardingAdminService } from "../../../../../../services/onboarding/onboarding-admin.service";
import { I18N } from "aurelia-i18n";
import { CloneOnboardingPluginRequest } from "../../../../../../models/onboarding/onboarding.models";

@autoinject
@transient()
export class CloneOnboardingPluginDialog {
    private _itemId: number;
    private _actionAfterClone: () => void;

    public displayName: string;
    public displayODataName: string;

    constructor(private dialogClient: DialogClientService,
        private onboardingAdminService: OnboardingAdminService,
        private notificationService: NotificationClientService,
        private i18N: I18N) {
    }

    activate(model: any) {
        this._itemId = model.itemId;
        this._actionAfterClone = model.actionAfterClone;
    }

    clone() {
        return new Promise<void>((resolve, reject) => {
            if (this.areThereEmptyFields()) {
                this.notificationService.show(this.i18N.tr("empty-fields"), this.i18N.tr("empty-fields-description"), NotificationType.Error);
                reject();
            }
            else {
                const request: CloneOnboardingPluginRequest = {
                    onboardingPluginId: this._itemId,
                    displayODataName: this.displayODataName,
                    displayName: this.displayName
                }

                this.onboardingAdminService.cloneOnboardingPlugin(request)
                    .then(response => {
                        if (response.existingPluginWithSameDisplayName) {
                            this.notificationService.show(this.i18N.tr('validation-error-text') + "!", "There is already a plugin with same Display Name", NotificationType.Error);
                            reject();
                            return;
                        } else if (response.existingPluginWithSameODataDisplayName) {
                            this.notificationService.show(this.i18N.tr('validation-error-text') + "!", "There is already a plugin with same OData Display Name", NotificationType.Error);
                            reject();
                            return;
                        } else if (response.existingEntityWithSameName) {
                            this.notificationService.show(this.i18N.tr('validation-error-text') + "!", "There is already an entity in the system with same name", NotificationType.Error);
                            reject();
                            return;
                        }
                        if (response.isSuccess) {
                            this.notificationService.show(this.i18N.tr("successful-cloning-text").replace('{0}', this.displayName), this.i18N.tr("onboarding-clone-success-text"), NotificationType.Success);
                        }

                        resolve();
                        this.dialogClient.hide();

                        if (this._actionAfterClone instanceof Function) {
                            this._actionAfterClone();
                        }
                    })
                    .catch(() => {
                        this.notificationService.show(this.i18N.tr("failed-cloning-text"), this.i18N.tr("onboarding-clone-failure-text"), NotificationType.Error);
                        reject();
                    });
            }
        });
    }

    areThereEmptyFields() {
        if (!this.displayName || !this.displayODataName) {
            return true;
        }
        else {
            return false;
        }
    }

    cancel() {
        this.dialogClient.hide();
    }
}
